import React from 'react'
import './styles.scss'

interface Props {
  coloured: boolean
  children: JSX.Element | string
}

export const Segment = ({ coloured, children }: Props) => (
  <div className={`Segment ${coloured ? 'coloured' : ''}`}>
    <div className='ui text container'>
      <div className='ta text'>{children && children}</div>
    </div>
  </div>
)
